/**
 * Returns the iframe src url.
 * @param presentationId The presentation id.
 * @param config The lesson preview config.
 * @param showFullscreenButton Whether to show the fullscreen button.
 * @param bundleId The bundle id.
 * @param fromWelcome Whether the preview is from the welcome page.
 * @param privateLibraryId The private library id.
 * @param isReadOnly Whether the preview is read-only or not.
 */
const getIframeSrc = (presentationId, config, showFullscreenButton, bundleId, fromWelcome, privateLibraryId, isReadOnly) => {
  const {
    baseUrl
  } = config;
  const params = new URLSearchParams();
  params.append('pin', presentationId);
  params.append('sf', showFullscreenButton ? 'true' : 'false');
  params.append('parent', config.parentUrl);
  if (bundleId) {
    params.append('bundleId', bundleId);
  }
  if (fromWelcome) {
    params.append('fw', 'true');
  }
  if (privateLibraryId) {
    params.append('plId', privateLibraryId.toString());
  }
  if (isReadOnly) {
    params.append('isSessionPreview', '3');
  }
  return `${baseUrl}?${params.toString()}`;
};

/**
 * Sends a postMessage to the iframe to change the current slide.
 * @param currentRef The iframe ref.
 * @param slideNumber The slide number to change to.
 */
const changeCurrentSlide = (currentRef, slideNumber) => {
  currentRef.contentWindow?.postMessage({
    action_type: 'LESSON_FRAMEWORK_SLIDE_NUMBER_SELECTED',
    type: 'nearpodMessage',
    payload: {
      slideNumber
    }
  }, '*');
};

/**
 * Checks if the iframe is ready to receive postMessage events.
 * @param event The event object.
 * @param config The lesson preview config.
 */
const isPreviewReady = (event, config) => {
  const iframeOrigin = new URL(config.baseUrl).origin;
  if (!event.data || event.origin !== iframeOrigin) return false;
  const eventType = event.data.type;
  const eventCode = event.data.code;
  const eventPayloadType = event.data.payload?.type;

  // There are two types of events that are sent from the iframe,
  // one is a nearpodMessage with a payload, the other has a code number.
  // We need to check for both.

  if (['np_tsv_ready', 'np_preview_ready'].includes(eventType) && eventCode === 1) {
    return true;
  }
  if (eventType === 'nearpodMessage' && eventPayloadType === 'np_preview_ready') {
    return true;
  }
  return false;
};

export { changeCurrentSlide, getIframeSrc, isPreviewReady };
//# sourceMappingURL=index.js.map
